/**
 * Wraps a route page in a fade/lift entrance animation.
 * Use as the outermost element of every page component:
 *   <PageTransition> ... </PageTransition>
 */
export default function PageTransition({ children, className = "" }) {
  return <div className={`page-in ${className}`}>{children}</div>;
}
